import type { GetOrganizationsDTO } from "@src/domain/dto/organizations";
import type {
  IOrganizationRepository,
  IOrganizationPaginatedResponse,
} from "@src/domain/repositories/organization";

export interface GetOrganizationsResult {
  items: IOrganizationPaginatedResponse["organizations"]["items"];
  total: number;
  page: number;
  limit: number;
}

/**
 * Get Organizations Use Case – thin orchestration: validate then fetch via repository.
 * Receives GetOrganizationsDTO and forwards to repository.
 */
export class GetOrganizationsUseCase {
  private readonly organizationRepository: IOrganizationRepository;

  constructor(organizationRepository: IOrganizationRepository) {
    this.organizationRepository = organizationRepository;
  }

  async execute(
    params: GetOrganizationsDTO,
    refetch?: boolean,
  ): Promise<GetOrganizationsResult> {
    try {
      const { data } = await this.organizationRepository.getOrganizations(
        params,
        refetch,
      );
      if (!data?.organizations) throw new Error("No organizations found");
      return data.organizations;
    } catch (error) {
      console.error("Failed to get organizations:", error);
      throw new Error("Failed to get organizations");
    }
  }
}
